<template>
    <div>
        <div class="form-row">
            <div class="form-group col-md-6 col-sm-6 col-6">
                <SOInputNominal
                    :ref="`kapasitas${id}`"
                    :title="'Kapasitas maksimal'"
                    :prefix-right="true"
                    :placeholder="'0,1'"
                    :required="true"
                    :use-comma="true"
                    :prefix="getSatuan"
                    :default-value="mesinCuci.kapasitas.formatted"
                    v-model="mesinCuci.kapasitas"
                    @input="onChangeNominal($event, 'load_max')"
                    @keyup="$emit('update:mesinCuci', mesinCuci)"
                />
                <ErrorMessage
                    class="error"
                    label="Kapasitas maksimal"
                    :validation="$v.posted.load_max"
                    :ref="`err_kapasitas${id}`"
                ></ErrorMessage>
            </div>
            <div class="form-group col-md-6 col-sm-6 col-6">
                <SOInputNominal
                    :ref="`toleransi${id}`"
                    :title="'Toleransi'"
                    :prefix-right="true"
                    :placeholder="'0,1'"
                    :use-comma="true"
                    :prefix="getSatuan"
                    :default-value="mesinCuci.toleransi.formatted"
                    v-model="mesinCuci.toleransi"
                    @input="onChangeNominal($event, 'load_toleransi')"
                    @keyup="$emit('update:mesinCuci', mesinCuci)"
                />
                <ErrorMessage
                    class="error"
                    label="Toleransi"
                    :validation="$v.posted.load_toleransi"
                    :ref="`err_toleransi${id}`"
                ></ErrorMessage>
            </div>
        </div>
        <div>
            <label class="remove-margin f-c-midgrey f-regular f-14 require" for="phone">Durasi mesin bekerja</label>
        </div>
        <div class="row remove-padding-margin">
            <div class="col-md-6 col-sm-6 col-6 remove-padding" style="padding-right: 4px">
                <InputMinPlus
                    v-model="mesinCuci.durasi_jam"
                    :id="`${id}_durasi_jam`"
                    :minValue="0"
                    :maxValue="23"
                    :metric="'Jam'"
                    :ref="`durasi_jam${id}`"
                    @input="onChangeNominal($event, 'durasi_jam')"
                    @keyup="$emit('update:mesinCuci', mesinCuci)"
                />
                <ErrorMessage
                    class="error"
                    label="Durasi mesin bekerja"
                    :validation="$v.posted.durasi_jam"
                ></ErrorMessage>
            </div>
            <div class="col-md-6 col-sm-6 col-6 remove-padding text-right" style="padding-left: 4px">
                <InputMinPlus
                    v-model="mesinCuci.durasi_menit"
                    :id="`${id}_durasi_menit`"
                    :minValue="0"
                    :maxValue="59"
                    :metric="'Menit'"
                    :ref="`durasi_menit${id}`"
                    @input="onChangeNominal($event, 'durasi_menit')"
                    @keyup="$emit('update:mesinCuci', mesinCuci)"
                />
                <ErrorMessage
                    class="error"
                    label="Durasi mesin bekerja"
                    :validation="$v.posted.durasi_menit"
                ></ErrorMessage>
            </div>
        </div>
        <div class="m-t-20 wrap-multi-select">
            <SOInputSelectMultiple
                :title="'Kategori Mesin'"
                :label="'title'"
                :required="true"
                :placeholder="'Pilih Kategori Mesin'"
                :track-by="'value'"
                :options="kategoriMesin"
                :multiple="true"
                :searchable="true"
                :taggable="true"
                :value="mesinCuci.kategori_mesin"
                @selected="selectedKategoriMesin"
            />
            <ErrorMessage
                class="error"
                label="Kategori Mesin"
                :validation="$v.posted.tag_mesin"
                :ref="`err_kategori_mesin${id}`"
            ></ErrorMessage>
        </div>
    </div>
</template>

<script>
import SOInputNominal from "@/so-components/global/input/SOInputNominal";
import InputMinPlus from "@/component-items/InputMinPlus";
import SOInputSelectMultiple from "@/so-components/global/input/SOInputSelectMultiple";
import ErrorMessage from "@/component-items/ErrorMessage";

import { minValue, required } from "vuelidate/lib/validators";

export default {
    name: "MesinCuci",
    components: {
        SOInputNominal,
        InputMinPlus,
        SOInputSelectMultiple,
        ErrorMessage,
    },
    props: {
        mesinCuci: {
            type: Object,
            required: true,
        },
        kategoriMesin: {
            type: Array,
            required: true,
        },
        id: {
            type: String,
            required: true,
        },
        satuan: {
            type: String,
            default: "Kg",
        }
    },
    data() {
        return {
            posted: {
                load_max: 0,
                load_toleransi: 0,
                durasi_jam: 0,
                durasi_menit: 0,
                tag_mesin: [],
            },
        };
    },
    async mounted() {
        await this.initKapasitas();
        await this.initToleransi();
        await this.initDurasiJam();
        await this.initDurasiMenit();
        await this.initTagMesin();
        await this.resetErrorValidate();
    },
    watch: {
        kapasitasMesin: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.initKapasitas();
            }
        },
        toleransiMesin: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.initToleransi();
            }
        },
        durasiJam: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.initDurasiJam();
            }
        },
        durasiMenit: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.initDurasiMenit();
            }
        },
        katMesin: function(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.initTagMesin();
            }
        },
    },
    validations: {
        posted: {
            load_max: {
                required,
            },
            durasi_jam: {
                required,
            },
            durasi_menit: {
                required,
            },
            tag_mesin: {
                required,
            },
        },
    },
    computed: {
        kapasitasMesin: function() {
            return this.mesinCuci.kapasitas.raw;
        },
        toleransiMesin: function() {
            return this.mesinCuci.toleransi.raw;
        },
        durasiJam: function() {
            return this.mesinCuci.durasi_jam;
        },
        durasiMenit: function() {
            return this.mesinCuci.durasi_menit;
        },
        katMesin: function() {
            return this.mesinCuci.kategori_mesin;
        },
        getSatuan: function() {
            return this.satuan === "Load" || this.satuan === "Koin" ? "Kg" : this.satuan;
        }
    },
    methods: {
        selectedKategoriMesin(val) {
            let selected = [];
            this.posted.tag_mesin = [];
            val.forEach((value) => {
                selected = selected.concat(value);
            });

            this.mesinCuci.kategori_mesin = selected;
            selected.forEach((item) => {
                this.posted.tag_mesin.push(item.title);
            });
        },
        onChangeNominal(e, target) {
            this.posted[target] = e.raw >= 0 ? e.raw : e;
        },
        initKapasitas() {
            if (this.kapasitasMesin) {
                this.$refs[`kapasitas${this.id}`].nominal.raw = this.mesinCuci.kapasitas.raw;
                this.$refs[`kapasitas${this.id}`].nominal.formatted = this.mesinCuci.kapasitas.formatted;
            }
        },
        initToleransi() {
            if (this.toleransiMesin) {
                this.$refs[`toleransi${this.id}`].nominal.raw = this.mesinCuci.toleransi.raw;
                this.$refs[`toleransi${this.id}`].nominal.formatted = this.mesinCuci.toleransi.formatted;
            }
        },
        initDurasiJam() {
            if (this.durasiJam) {
                this.$refs[`durasi_jam${this.id}`].val = this.mesinCuci.durasi_jam;
                this.posted.durasi_jam = this.mesinCuci.durasi_jam;
            }
        },
        initDurasiMenit() {
            if (this.durasiMenit) {
                this.$refs[`durasi_menit${this.id}`].val = this.mesinCuci.durasi_menit;
                this.posted.durasi_menit = this.mesinCuci.durasi_menit;
            }
        },
        initTagMesin() {
            if (this.katMesin.length > 0) {
                this.katMesin.forEach((kat) => {
                    this.posted.tag_mesin.push(kat.title);
                });
            }
        },
        errorValidate() {
            let { load_max, durasi_jam, durasi_menit, tag_mesin } = this.$v.posted;

            load_max.$touch();
            durasi_jam.$touch();
            durasi_menit.$touch();
            tag_mesin.$touch();

            return (
                load_max.$invalid ||
                durasi_jam.$invalid ||
                durasi_menit.$invalid ||
                tag_mesin.$invalid
            );
        },
        resetErrorValidate() {
          this.$refs[`err_kapasitas${this.id}`].resetValidation();
          this.$refs[`err_toleransi${this.id}`].resetValidation();
          this.$refs[`err_kategori_mesin${this.id}`].resetValidation();
        },
        resetData() {
            this.posted = {
                load_max: 0,
                load_toleransi: 0,
                durasi_jam: 0,
                durasi_menit: 0,
                tag_mesin: [],
            };
            this.mesinCuci.kapasitas.raw = 0;
            this.mesinCuci.kapasitas.formatted = "0";
            this.mesinCuci.toleransi.raw = 0;
            this.mesinCuci.toleransi.formatted = "0";
            this.mesinCuci.durasi_jam = 0;
            this.mesinCuci.durasi_menit = 0;
            this.mesinCuci.kategori_mesin = [];

            this.$refs[`durasi_jam${this.id}`].val = 0;
            this.$refs[`durasi_menit${this.id}`].val = 0;

            this.resetErrorValidate();

            this.$emit("update:mesinCuci", this.mesinCuci);
        },
    },
};
</script>
<style scoped>
.wrap-multi-select {
    position: relative;
    z-index: 900;
}
</style>
